export const common = {
  // Brand
  brandName: 'EachTeach',

  // Language names (LanguageSwitcher)
  languageName: '日本語',
  changeLanguage: '言語を変更',

  // Navbar
  nav: {
    home: 'ホーム',
    courseFlow: 'コースの流れ',
    services: 'サービス・ツール',
    register: 'コミュニティ登録',
    menu: 'メニュー',
  },

  // Footer
  footer: {
    mission:
      '個人言語家庭教師と専門家が共に学び、教育の質を高め合えるコミュニティ。「教える」をもっと自由に、もっと身近に。',
    community: 'コミュニティ',
    communityRegister: 'コミュニティ登録',
    services: 'サービス・ツール',
    about: 'About',
    aboutEachTeach: 'EachTeachについて',
    philosophy: '理念・ミッション',
    allRightsReserved: 'All rights reserved.',
  },

  // Shared actions / states
  close: '閉じる',
  cancel: 'キャンセル',
  submit: '送信',
  submitting: '送信中...',
  loading: '読み込み中...',
  required: '必須',
  optional: '任意',
};
